import '@/styles/globals.css';
import { AppProps } from 'next/app';
import { Box, ThemeProvider } from '@mui/material';
import { theme } from '@/theme';
import { appWithTranslation } from 'next-i18next';
import { Provider } from 'react-redux';
import wrapper from '../store';
import { Toast } from '@/components';
import Head from 'next/head';
import { FC } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { google_client_id } from '@/utils';
import GoogleTagManager from '@/components/GoogleTagManager';
import ErrorBoundary from '@/components/ErrorBoundary';
import { PaletteProvider } from '@/hooks/PaletteContext';
import { AuthProvider } from '@/hooks/authContext';

const App: FC<AppProps> = ({ Component, ...rest }) => {
  const { store, props } = wrapper.useWrappedStore(rest);
  const GOOGLE_CLIENT_ID = google_client_id;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider> {/* Wrap the app inside AuthProvider */}
        <PaletteProvider>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <ErrorBoundary>
                <Toast />
                <Head>
                  <title>Memvy</title>
                  <meta name="viewport" content="width=device-width, initial-scale=1" />
                </Head>
                <GoogleTagManager />
                <Box width="100%">
                  <Component {...props} />
                </Box>
              </ErrorBoundary>
            </Provider>
          </ThemeProvider>
        </PaletteProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default appWithTranslation(App);
